import { Component, signal, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { RoutingUtilService, stringToBoolean } from '@pflegix/util';
import { OrderDetailsSidebarComponent } from '../order-details-sidebar.component';

@Component({
  selector: 'pfx-order-details-sidebar-container',
  imports: [OrderDetailsSidebarComponent],
  templateUrl: './order-details-sidebar-container.component.html',
})
export class OrderDetailsSidebarContainerComponent {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);

  public orderId = signal('');

  public viewOrder = signal(false);

  constructor() {
    this.activatedRoute.queryParamMap.pipe(takeUntilDestroyed()).subscribe((params) => {
      this.orderId.set(params.get('sidebarOrderId') ?? '');
      this.viewOrder.set(stringToBoolean(params.get('viewSidebarOrder') ?? ''));
    });
  }

  protected handleSidebarVisibleChanged(visible: boolean): void {
    if (visible) {
      return;
    }

    RoutingUtilService.removeQueryParams(this.router, this.activatedRoute, ['sidebarOrderId', 'viewSidebarOrder']);
  }
}
